import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-sandDark bg-ivory px-5 py-7 sm:px-8" data-id="element-50" data-mp="32wd2qgad7ltj">
      <div className="mx-auto w-full max-w-content text-center" data-id="element-51" data-mp="3gg0za3iktxxn">
        <p className="font-serif text-sm uppercase tracking-label text-forest" data-id="element-52" data-mp="32oe2m2kq2nec">
          Yoga Teacher System™
        </p>
        <p className="mx-auto mt-4 max-w-xl text-xs leading-relaxed text-muted" data-id="element-53" data-mp="36qhg0wqyc229">
          Yoga Teacher System™ is a digital teaching resource for yoga instructors. It does not
          replace professional training or certification, and it is not medical advice. Teachers are
          responsible for adapting all classes to the students in their room.
        </p>
        <p className="mt-5 text-[0.65rem] uppercase tracking-label text-muted" data-id="element-54" data-mp="3qd6spieny111">
          © {new Date().getFullYear()} Yoga Teacher System™ · All rights reserved
        </p>
      </div>
    </footer>;
}